import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function StepName({ form, setForm, next }) {
  const canProceed = form.name.trim() && form.iata.trim().length === 2;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-light mb-2" style={{ color: 'var(--text-primary)' }}>
          Airline Identity
        </h1>
        <p className="text-sm font-light" style={{ color: 'var(--text-secondary)' }}>
          Enter your airline's official name and two-letter IATA code.
        </p>
      </div>

      <div className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="name" className="text-sm font-normal" style={{ color: 'var(--text-secondary)' }}>
            Airline Name
          </Label>
          <Input
            id="name"
            placeholder="e.g., Skyline Airways"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="rounded-sm"
            style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)', color: 'var(--text-primary)' }}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="iata" className="text-sm font-normal" style={{ color: 'var(--text-secondary)' }}>
            IATA Code
          </Label>
          <Input
            id="iata"
            placeholder="e.g., SK"
            value={form.iata}
            maxLength={2}
            onChange={(e) => setForm({ ...form, iata: e.target.value.toUpperCase() })}
            className="rounded-sm uppercase"
            style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)', color: 'var(--text-primary)' }}
          />
          <p className="text-xs font-light" style={{ color: 'var(--text-muted)' }}>
            Must be exactly 2 letters
          </p>
        </div>
      </div>

      <div className="flex justify-end pt-4" style={{ borderTopWidth: '1px', borderColor: 'var(--border)' }}>
        <Button
          onClick={next}
          disabled={!canProceed}
          className="font-normal px-8 rounded-sm"
          style={{ backgroundColor: 'var(--neon)', color: '#000' }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}